/**
 * Slider labels and value formatting. Pure and unit-aware; also
 * supplies each slider's `aria-valuetext`. Kept out of the component file so
 * fast-refresh stays happy.
 */
import type { NumericField, Units } from "./config";
import { kmhToKt, msToKt } from "./units";

export const SLIDER_LABELS: Record<NumericField, string> = {
  pilotWeight_kg: "Pilot weight",
  waterBallast_kg: "Water ballast",
  bugsPercent: "Bugs / degradation",
  macCready_ms: "MacCready setting",
  windHeadwind_kmh: "Headwind (+) / Tailwind (−)",
};

/**
 * Combined water-ballast readout: "<water> kg / <wing loading> kg/m²".
 * Mass stays metric regardless of the unit toggle. Lives here rather
 * than in `formatSliderValue` because it needs the glider's wing loading, which
 * the slider table does not carry.
 */
export const formatBallastValue = (water_kg: number, wingLoading_kg_m2: number): string =>
  `${water_kg.toFixed(0)} kg / ${wingLoading_kg_m2.toFixed(1)} kg/m²`;

export const formatSliderValue = (
  field: NumericField,
  value: number,
  units: Units,
): string => {
  switch (field) {
    case "pilotWeight_kg":
    case "waterBallast_kg":
      return `${value.toFixed(0)} kg`;
    case "bugsPercent":
      return `${value.toFixed(0)}%`;
    case "macCready_ms":
      return units === "metric"
        ? `${value.toFixed(1)} m/s`
        : `${msToKt(value).toFixed(1)} kt`;
    case "windHeadwind_kmh":
      return units === "metric"
        ? `${value.toFixed(0)} km/h`
        : `${kmhToKt(value).toFixed(0)} kt`;
  }
};
